import Vue from "vue";
import vuex from "vuex";

import user from "./modules/user";

import global from "./global";
import getters from "./getters";

Vue.use(vuex);

const store = new vuex.Store({
    modules: {
     
        global,
        user,
        
    },
    getters,
});

export default store;